import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { usePlayer } from "@/contexts/PlayerContext";
import { youtubeEmbed } from "@/data/site";

export const VideoModal = () => {
  const { video, close } = usePlayer();

  useEffect(() => {
    if (!video) return;
    const onKey = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKey);
    window.__lenis?.stop();
    return () => {
      window.removeEventListener("keydown", onKey);
      window.__lenis?.start();
    };
  }, [video, close]);

  return (
    <AnimatePresence>
      {video && (
        <motion.div
          data-testid="video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4"
          onClick={close}
        >
          <button
            data-testid="video-modal-close"
            onClick={close}
            aria-label="Close player"
            className="absolute top-5 right-5 z-10 w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-white hover:border-[#C8F031] hover:text-[#C8F031] transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
          <motion.div
            initial={{ scale: 0.92, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className={`relative bg-black rounded-2xl overflow-hidden ring-1 ring-white/10 ${
              video.aspect === "9:16"
                ? "h-[82vh] aspect-[9/16]"
                : "w-[92vw] max-w-5xl aspect-video"
            }`}
          >
            <iframe
              src={
                video.youtubeId
                  ? youtubeEmbed(video.youtubeId)
                  : `${video.embedUrl}?autoplay=true&muted=false&responsive=true&preload=true`
              }
              title={video.industry}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full border-0"
            />
          </motion.div>
          <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[10px] font-heading uppercase tracking-[0.2em] text-white/40 pointer-events-none">
            {video.industry} — {video.capability}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VideoModal;
